import user from "./user";
import order from "./order";
import activity from "./activity";
import admin from "./admin";
import game from "./game";
import evaluation from "./evaluation";

export default [...user, ...order, ...activity, ...admin, ...game, ...evaluation];